import React from 'react';
import { observer } from 'mobx-react';
import { FolderIcon } from '../../../VaultFilters/icons';
import {
    SubscriptionDocsIcon,
    LiabilitiesDocsIcon,
    Form1099Icon,
    K1Icon,
    AccountStatementsIcon,
    TickersIcon,
    BalanceSheetPfsIcon,
    OtherIcon,
    Custom01Icon,
    Custom02Icon,
    Custom03Icon,
    Custom04Icon,
    Custom05Icon,
    Custom06Icon,
    Custom07Icon,
    Custom08Icon,
    Custom09Icon,
    Custom10Icon,
    Custom11Icon,
    Custom12Icon,
    Custom13Icon,
    Custom14Icon,
    Custom15Icon,
    Custom16Icon,
    Custom17Icon,
    Custom18Icon,
    Custom19Icon,
    Custom20Icon,
    Custom21Icon,
    Custom22Icon,
    Custom23Icon,
    Custom24Icon,
    Custom25Icon
} from './icons';

const PREDEFINED_TAG_ICONS = {
    'subscription_documents': SubscriptionDocsIcon,
    'liabilities_documents': LiabilitiesDocsIcon,
    'account_statements': AccountStatementsIcon,
    'k1': K1Icon,
    'form_1099': Form1099Icon,
    'tickers': TickersIcon,
    'balance_sheet': BalanceSheetPfsIcon,
    'other': OtherIcon
};

const CUSTOM_TAG_ICONS = [
    Custom01Icon, Custom02Icon, Custom03Icon, Custom04Icon, Custom05Icon,
    Custom06Icon, Custom07Icon, Custom08Icon, Custom09Icon, Custom10Icon,
    Custom11Icon, Custom12Icon, Custom13Icon, Custom14Icon, Custom15Icon,
    Custom16Icon, Custom17Icon, Custom18Icon, Custom19Icon, Custom20Icon,
    Custom21Icon, Custom22Icon, Custom23Icon, Custom24Icon, Custom25Icon
];

const getCustomTagIcon = (tagName) => {
    const hash = tagName.split('').reduce((a, b) => {
        a = ((a << 5) - a) + b.charCodeAt(0);
        return a & a;
    }, 0);
    
    const iconIndex = Math.abs(hash) % CUSTOM_TAG_ICONS.length;
    return CUSTOM_TAG_ICONS[iconIndex];
};

const SafeSVGIcon = ({ IconComponent, tagName, size }) => {
    const uniqueId = React.useMemo(() => 
        `tag-${tagName.replace(/[^a-zA-Z0-9]/g, '')}-${Math.random().toString(36).substr(2, 9)}`,
        [tagName]
    );
    
    const svgRef = React.useRef(null);
    
    React.useEffect(() => {
        if (svgRef.current) {
            const svg = svgRef.current.querySelector('svg');
            if (svg) {
                const gradients = svg.querySelectorAll('linearGradient, radialGradient');
                gradients.forEach((gradient, index) => {
                    const oldId = gradient.id;
                    const newId = `${uniqueId}-gradient-${index}`;
                    
                    gradient.id = newId;
                    
                    const elementsUsingGradient = svg.querySelectorAll(`[fill="url(#${oldId})"]`);
                    elementsUsingGradient.forEach(element => {
                        element.setAttribute('fill', `url(#${newId})`);
                    });
                });
            }
        }
    }, [uniqueId]);
    
    return (
        <div 
            ref={svgRef}
            style={{ 
                display: 'inline-block', 
                width: size, 
                height: size,
                lineHeight: 0
            }}
        >
            <IconComponent 
                width={size} 
                height={size} 
                style={{ display: 'block' }}
            />
        </div>
    );
};

export const SmartTagIcon = observer(({ tagName, size = 24 }) => {
    
    const safeTagName = tagName && typeof tagName === 'string' ? tagName : '';
    
    if (!safeTagName) {
        return <FolderIcon />;
    }
    
    let PredefinedIcon = PREDEFINED_TAG_ICONS[safeTagName];
    
    if (!PredefinedIcon) {
        PredefinedIcon = PREDEFINED_TAG_ICONS[safeTagName.toLowerCase()];
    }
    
    if (!PredefinedIcon) {
        const normalizedTagName = safeTagName.toLowerCase().replace(/\s+/g, '-');
        PredefinedIcon = PREDEFINED_TAG_ICONS[normalizedTagName];
    }
    
    if (PredefinedIcon) {
        return <SafeSVGIcon IconComponent={PredefinedIcon} tagName={safeTagName} size={size} />;
    }
    
    const CustomIcon = getCustomTagIcon(safeTagName);
    return <SafeSVGIcon IconComponent={CustomIcon} tagName={safeTagName} size={size} />;
}); 